module.exports = __webpack_public_path__ + "static/media/pinterest.4b47b9a6.svg";